<emm-management-layout>
    <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
    <emm-search-filter
        [addDialog]="true"
        [attr.data-testid]="'item_type_search_bar'"
        [displaySearchWithOptions]="false"
        [fields]="fields$ | async"
        [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
        [isSuperAdmin]="this.isSuperAdmin"
        [componentName]="'item-types'"
        layout-center-header
        (add)="openCreateItemTypeDialog()"
        (filter)="onFilter($event)"
    ></emm-search-filter>
    <emm-generic-items-list
        [contextMenuActions]="itemTypesContextMenuActions"
        [disableContextActions]="anyLoading$ | async"
        [isReadOnly]="isReadOnly$ | async"
        [items]="itemTypesAsGenericItems$ | async"
        layout-center-content
        (onSelectItem)="onSelectItemType($event)"
    ></emm-generic-items-list>
    <emm-management-attributes-header
        *ngIf="itemDetail$ | async as item"
        layout-right-header
        [name]="item.name"
        [tag]="item.tag"
    ></emm-management-attributes-header>
    <emm-item-types-form
        #form
        layout-right-content
        [isSuperAdmin]="isSuperAdmin"
        [isAdmin]="isAdmin"
    ></emm-item-types-form>
    <emm-management-attributes-footer
        *ngIf="itemDetail$ | async as item"
        [disableCancel]="!itemTypesForm || !itemTypesForm.isFormReady()"
        [disableUpdate]="!itemTypesForm || !itemTypesForm.hasChanges()"
        layout-right-footer
        (cancel)="itemTypesForm.cancel()"
        (submit)="itemTypesForm.submit(item.tag)"
        class="item-types-footer"
    ></emm-management-attributes-footer>
</emm-management-layout>
